import { InputMultiSelectControl, MultiSelect } from '../../Select'
import Label from '../Label'
import { getLabelColor, getLabelLabel } from '../Label.utils'
import { LabelSelect } from '../LabelSelect'

function LabelMultiSelect({
  Control = InputMultiSelectControl,
  tagSize,
  onClear,
  onSelectItem,
  ...restProps
}) {
  return (
    <MultiSelect
      {...restProps}
      multi
      Control={Control}
      Select={LabelSelect}
      tagsProps={{
        TagComponent: Label,
        getColor: getLabelColor,
        getText: getLabelLabel,
        size: tagSize,
        onChange: onSelectItem,
        onClear,
      }}
      onClear={onClear}
      onSelectItem={onSelectItem}
    />
  )
}

export default LabelMultiSelect
